import { App, BackButtonListener } from '@capacitor/app';

/**
 * Registers a handler for the Android hardware back gesture. Returns a cleanup function.
 *
 * Registering at all disables the plugin's own handling, so the handler owns the gesture entirely,
 * including exiting the app. Native-only: the caller is mounted behind an isNativePlatform() check.
 */
export function onHardwareBack(listener: BackButtonListener): () => void {
    const registration = App.addListener('backButton', listener);

    return () => {
        registration.then((backButtonListener) => backButtonListener.remove());
    };
}
